import React, {Fragment ,useState, useEffect} from 'react'
import AddOrEditBook from "./AddOrEditBookForm";
import {getBookCategories} from "./actions";
import {connect} from 'react-redux' ;
import {getBookInfo} from "./actions";
import _ from 'lodash' ;
import {addBook , editBook} from "./actions";
import {withRouter} from 'react-router-dom' ;
import {reset} from 'redux-form' ;

const AddBooks = (props) => {

    const {id} = props.match.params ;
    const {singleBook , bookCategories , postBookResult} = props ;
    const [bookInitialValues , setBookInitialValues] = useState({}) ;
    const [renderForm , setRenderForm] = useState(false) ;
    const [loading , setLoading] = useState(false) ;
    const [postBookResultMessage , setPostBookResultMessage] = useState(null) ;

    const onFormSubmit = (values) => {
      console.log(values);
      setLoading(true) ;
      let data = {
            name : values.name ,
            enName : '' ,
            price : parseInt(values.price) ,
            authorName : values.authorName ,
            thumbnailId : values.thumbnailId,
            categoryId : values.category.value ,
            description : values.description ,
            isbn : values.isbn ,
            publisher : values.publisher ,
            translators : values.translators ,
      };
      if (id === 'new') {
            props.addBook(data) ;
      }
      else {
          data = {...data , id : Number(id)} ;
          props.editBook(Number(id), data) ;
      }

    };

    const bookFormInitialValues = () => {
        if (id === 'new') {
            return {} ;
        }
        else {
            return _.isEmpty(singleBook) ? {} : {
                name : singleBook.name ,
                price : singleBook.price ,
                authorName : singleBook.authorName ,
                publisher : singleBook.publisher ,
                translators : singleBook.translators ,
                isbn : singleBook.isbn ,
                category : {value : singleBook.categoryId , label : singleBook.category} ,
                description : singleBook.description,
                thumbnailId : singleBook.thumbnailId
            };
        }
    };

    // useEffect(() => {
    //     props.getBookCategories();
    // } ,[]);

    useEffect(() => {
        props.getBookCategories();
        console.log('id change', id)
        if (id !== 'new') {
            setRenderForm(false);
            props.getBookInfo(id) ;
        }
        else {
            props.reset("AddOrEditBook") ;
        }
    } ,[]);

    useEffect(() => {
        if (!_.isEmpty(singleBook)) {
            setBookInitialValues(bookFormInitialValues()) ;
            setRenderForm(true) ;
        }
        else {
            setBookInitialValues({}) ;
        }
        if (id === 'new') {
            setRenderForm(true) ;
        }
    } , [singleBook]);

    useEffect(() => {
        if (!_.isEmpty(postBookResult)) {
            setLoading(false) ;
            if (postBookResult.isSuccess) {
                if (id === 'new') {
                    props.history.push('/books') ;
                }
                else {
                    setPostBookResultMessage({success : true , message : postBookResult.message}) ;
                }
            }
            else{
                setPostBookResultMessage({success : false , message : postBookResult.message}) ;
            }
        }
    } ,[postBookResult]);
    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle">
                    <span className=" font-size_24 boldFont middleContext">{id === 'new' ? `افزودن کتاب جدید` : `به روز رسانی کتاب`}</span>
                </div>
            </div>
            <span className="lineSeparator"></span>
            {renderForm ? <AddOrEditBook onSubmit={onFormSubmit} initialValues={bookInitialValues} isAdd={id === 'new'} loading={loading}/> : null}
        </Fragment>
    );
};

const mapStateToProps = (state ,ownProps) => {
    return {
        singleBook : state.singleBook ,
        bookCategories : state.bookCategories ,
        postBookResult : state.postBookResult
    };
};

export default connect(mapStateToProps , {getBookCategories , getBookInfo , editBook , addBook , reset})(withRouter(AddBooks));
